import React from 'react';

const TableRelations = ({tableItems}) => {
  return (
    <table className='table__domains'>
      <thead>
      <tr className='iransans-m table__domains__head'>
        <th style={{width: "36px"}}>ردیف</th>
        <th style={{width: "68px"}}>کد رابطه</th>
        <th style={{width: "89px"}}>نام رابطه</th>
        <th style={{width: "90px"}}>زیر سیستم</th>
        <th style={{width: "90px"}}>کد ورژن</th>
        <th>وظیفه</th>
      </tr>
      </thead>
      <tbody>
      {tableItems ? tableItems.map((item, index) => (
        <tr key={index} className='iransans-b table__domains__desc'>
          <td>{index+1}</td>
          <td>{item.id}</td>
          <td>{item.name}</td>
          <td>{item.subsystemName}</td>
          <td>{item.version}</td>
          <td></td>
        </tr>
      )) : null}
      </tbody>

    </table>
  );
};

export default TableRelations;